import { create } from 'zustand';
import type { StoreApi, UseBoundStore } from 'zustand';

/**
 * Estado de identidade da sessão. **Só identidade** — dado de servidor mora no
 * TanStack Query, que tem invalidação e deduplicação; este store não tem nem um
 * nem outro (ADR-003 dos dois apps).
 */
export interface AuthState<TStoredAuth> {
  auth: TStoredAuth | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  setAuth: (auth: TStoredAuth) => void;
  clearAuth: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

/**
 * Fábrica em vez de store pronto: cada app instancia o seu, com o formato de
 * snapshot que usa. Um store no módulo compartilhado seria um singleton entre
 * apps que nunca rodam juntos — e amarraria os dois ao mesmo formato.
 */
export function createAuthStore<TStoredAuth>(): UseBoundStore<
  StoreApi<AuthState<TStoredAuth>>
> {
  return create<AuthState<TStoredAuth>>((set) => ({
    auth: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    // Entrar limpa o erro: a mensagem da tentativa anterior não sobrevive ao
    // sucesso desta.
    setAuth: (auth) => set({ auth, isAuthenticated: true, error: null }),
    clearAuth: () => set({ auth: null, isAuthenticated: false }),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
  }));
}
